var moduleMap = {
	"./MainLayout": () => {
		return Promise.all([__webpack_require__.e(552), __webpack_require__.e(354), __webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(314), __webpack_require__.e(720), __webpack_require__.e(305)]).then(() => (() => ((__webpack_require__(3958)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(192)]).then(() => (() => ((__webpack_require__(2192)))));
	},
	"./TimeConnected": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(314), __webpack_require__.e(878)]).then(() => (() => ((__webpack_require__(1878)))));
	},
	"./AppMultiSelect": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(592)]).then(() => (() => ((__webpack_require__(3592)))));
	},
	"./NotAuthorized": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(548), __webpack_require__.e(402)]).then(() => (() => ((__webpack_require__(5402)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(552), __webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(954)]).then(() => (() => ((__webpack_require__(6077)))));
	},
	"./AppSelect": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(868)]).then(() => (() => ((__webpack_require__(7487)))));
	},
	"./AppSwitch": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(847)]).then(() => (() => ((__webpack_require__(2847)))));
	},
	"./AppInput": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(499)]).then(() => (() => ((__webpack_require__(9499)))));
	},
	"./AppTextArea": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(893)]).then(() => (() => ((__webpack_require__(5893)))));
	},
	"./AppCustomCheckbox": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(275)]).then(() => (() => ((__webpack_require__(8275)))));
	},
	"./AppButton": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(143)]).then(() => (() => ((__webpack_require__(7143)))));
	},
	"./ManageSideDrawer": () => {
		return Promise.all([__webpack_require__.e(552), __webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(378)]).then(() => (() => ((__webpack_require__(6799)))));
	},
	"./RecordTotalCount": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(940)]).then(() => (() => ((__webpack_require__(940)))));
	},
	"./AppPagination": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(117)]).then(() => (() => ((__webpack_require__(5117)))));
	},
	"./AppCustomizedPagination": () => {
		return Promise.all([__webpack_require__.e(552), __webpack_require__.e(914), __webpack_require__.e(444), __webpack_require__.e(548), __webpack_require__.e(181)]).then(() => (() => ((__webpack_require__(9715)))));
	},
	"./EnvironmentVariables": () => {
		return __webpack_require__.e(125).then(() => (() => ((__webpack_require__(1125)))));
	},
	"./Types": () => {
		return __webpack_require__.e(748).then(() => (() => ((__webpack_require__(3748)))));
	},
	"./IndexStyle": () => {
		return Promise.all([__webpack_require__.e(207), __webpack_require__.e(632)]).then(() => (() => ((__webpack_require__(662)))));
	},
	"./LayoutStyle": () => {
		return __webpack_require__.e(222).then(() => (() => ((__webpack_require__(4222)))));
	},
	"./OverrideStyle": () => {
		return __webpack_require__.e(64).then(() => (() => ((__webpack_require__(6064)))));
	},
	"./IconSvg": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(518)]).then(() => (() => ((__webpack_require__(518)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});